import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import DualFormRequirement from 'common/Accounts/DualFormRequirement';

class WithholdingTable extends Component {
  static propTypes = {
    accountWithholding: PropTypes.shape({
      rates: PropTypes.arrayOf(PropTypes.shape({})),
      isDualFormSatisfied: PropTypes.bool,
      dualFormRequirement: PropTypes.number,
      hasQddElection: PropTypes.bool,
      hasWithholdingStatement: PropTypes.bool,
      hasFatcaExemptions: PropTypes.bool,
      hasExemptPayeeCodes: PropTypes.bool
    })
  };

  static defaultProps = {
    accountWithholding: null
  };

  render() {
    const { accountWithholding } = this.props;

    function hasRates(item, type) {
      if (item == null || item.rates == null || item.rates.length === 0) {
        return false;
      }

      return item.rates.some(rate => rate && rate.whdCategory === type);
    }

    function getRate(rate) {
      return `${ parseFloat(rate * 100).toFixed(2) }%`;
    }

    return (
      <div>
        <div className="panel-body-caption">
          <label className="panel-text" id="whd-rates-table-applied-rates-name"><strong>Applied Rates: </strong></label>
        </div>
        { accountWithholding != null && accountWithholding.isDualFormSatisfied && accountWithholding.dualFormRequirement === DualFormRequirement.QDD
          && <div className="toast toast-info mb-10 text-center">The rates below are based upon the Form BEN-E provided by the QDD.</div> }
        { accountWithholding != null && accountWithholding.hasQddElection
          && <div className="toast toast-info mb-10 text-center">
            <p><strong>You must rely on the qualified derivatives dealers statement to identify appropriate withholding.</strong></p>
            <p>The below rate for 871m payments is based on the fact that the QDD is acting as a Principal.</p>
            <p>If this account extends to other Qualified Intermediary activities and new forms provided, this 871m rate may no longer apply.</p>
          </div> }
        { accountWithholding != null && accountWithholding.hasWithholdingStatement
          && <div className="toast toast-info mb-10 text-center">This Form W-8IMY is part of a structure. Navigate to the tree structure in order to view withholding rates.</div> }
        { accountWithholding != null && !accountWithholding.hasWithholdingStatement && hasRates(accountWithholding, 'Applied')
          && <table className="table table-bordered table-striped table-hover" id="whd-rates-table-applied-rates-values">
            <thead>
              <tr>
                <th className="col-2">Payment Type</th>
                <th className="col-2">Withholding Type</th>
                <th className="col-2">Withholding Rate</th>
                <th className="col-2">Reporting Type</th>
                { accountWithholding.hasFatcaExemptions && <React.Fragment>
                  <th className="col-2">Ch.3 Exemption</th>
                  <th className="col-2">Ch.4 Exemption</th>
                </React.Fragment> }
                { accountWithholding.hasExemptPayeeCodes && <th className="col-2">Exempt Payee Code</th> }
              </tr>
            </thead>
            <tbody>
              { accountWithholding.rates.map(rate => (rate
                  && rate.whdCategory === 'Applied' && <tr key={ rate.id }>
                    <td>{ rate.paymentTypeDescription }</td>
                    <td>{ rate.whdTypeDescription }</td>
                    <td>{ getRate(rate.appliedRate) }</td>
                    <td>{ rate.reportingTypeDescription }</td>
                    { accountWithholding.hasFatcaExemptions && <React.Fragment>
                      <td>{ rate.chapter3Exemption != null ? `${ rate.ch3ExemptionCode } - ${ rate.ch3ExemptionDescription }` : 'N/A' }</td>
                      <td>{ rate.chapter4Exemption != null ? `${ rate.ch4ExemptionCode } - ${ rate.ch4ExemptionDescription }` : 'N/A' }</td>
                    </React.Fragment> }
                    { accountWithholding.hasExemptPayeeCodes && <td>{ rate.exemptPayeeCodeString ?? 'N/A' }</td> }
                  </tr>
              )) }
            </tbody>
          </table> }
        { accountWithholding != null && !accountWithholding.hasQddElection && !accountWithholding.hasWithholdingStatement && !hasRates(accountWithholding, 'Applied') && <div className="no-rates">
          <h2>Insufficient information to calculate rates</h2>
          </div> }
        { accountWithholding != null && !accountWithholding.hasQddElection && !accountWithholding.hasWithholdingStatement && <React.Fragment>
          <div className="panel-body-caption">
            <label className="panel-text" id="whd-rates-table-state-rates-name"><strong>State Rates: </strong></label>
          </div>
          {hasRates(accountWithholding, 'State') && <table className="table table-bordered table-striped table-hover" id="whd-rates-table-state-rates-values">
            <thead>
              <tr>
                <th className="col-2">Payment Type</th>
                <th className="col-2">Withholding Type</th>
                <th className="col-2">Withholding Rate</th>
                <th className="col-2">State</th>
                { accountWithholding.hasExemptPayeeCodes && <th className="col-2">Exempt Payee Code</th> }
              </tr>
            </thead>
            <tbody>
              { accountWithholding.rates.map(rate => (rate
                  && rate.whdCategory === 'State' && <tr key={ rate.id }>
                    <td>{ rate.paymentTypeDescription }</td>
                    <td>{ rate.whdTypeDescription }</td>
                    <td>{ getRate(rate.appliedRate) }</td>
                    <td>{ rate.stateDescription }</td>
                    { accountWithholding.hasExemptPayeeCodes && <td>{ rate.exemptPayeeCodeString ?? 'N/A' }</td> }
                  </tr>
              )) }
            </tbody>
          </table> }
          { accountWithholding != null && !hasRates(accountWithholding, 'State') && <div className="no-rates">
            <h2 id="whd-rates-table-no-state-rates-name">State rates are not available</h2>
          </div> }
        </React.Fragment> }
      </div>
    );
  }
}

export default WithholdingTable;
